export default __webpack_public_path__ + "assets/images/46f6dba2b152283b072e62a75dfac692.svg";